module.exports = __webpack_public_path__ + "img/fireplace_comp_001.ee8d3c4c.jpg";